// Import React, styles, SVG icons, and navigation hook
import React from "react";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
import { useNavigate } from "react-router-dom";

/**
 * Footer component displays contact info, social links, and legal disclaimers.
 */
function Footer() {
  // useNavigate hook for client-side navigation
  const navigate = useNavigate();
  return (
    <footer className="background-container  bg-gray-3" id="contact">
      {/* Legal disclaimer and privacy policy link */}
      <div className="background-container  bg-primary-1 gap-m">
        <div className="content-container column gap-s align-center">
          {/* <h2
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => navigate("/privacy-policy")}
        >
          Privacy Policy
        </h2> */}
          <div className="body1">
            If you wish to register a complaint, please write to Complaints
            Officer, Rosemount Financial Solutions IFA Ltd, Rosemount House, 2-4
            Chequers Road, Basingstoke, RG21 7PU.  Telephone 01256 405460 or
            email complaints to complaints@rosemountfsIFA.co.uk. A summary of our
            internal complaints handling procedures for the reasonable and
            prompt handling of complaints is available on request and if you
            cannot settle your complaint with us, you may be entitled to refer
            it to the Financial Ombudsman Service
            at: https://www.financial-ombudsman.org.uk/ or by contacting them on
            0800 023 4567.
            {/*
            <a
              href="https://register.fca.org.uk/s/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              (https://register.fca.org.uk/s/)
            </a>
            under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
            authorised and regulated by the Financial Conduct Authority.
          */}
          </div>

          <div className="body1">
            Duo Financial is a trading style of Contractor Financial Limited which is
            an Appointed Representative of Rosemount Financial Solutions (IFA)
            Ltd which is authorised and regulated by the Financial Conduct
            Authority. Rosemount Financial Solutions (IFA) Ltd is entered on the
            Financial Services Register under reference 535515. Contractor
            Financial Limited is registered in England and Wales (Company
            Number: 15401629). Registered Address: John White Community Centre,
            Grange Avenue, Coventry, West Midlands, England, CV3 2ED. The
            information on this website is subject to the UK regulatory regime
            and is intended for consumers in the UK.
          </div>
          <div
            className="body2-semibold"
            onClick={() => navigate("/privacy-policy")}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
